import { useState, useEffect } from 'react'
import { CircularProgressContinuousSized } from './CircularProgressContinuous'
import { kDefaultLogoPath } from '@/constants/constants-ui'

type FullPageLoaderProps = {
  statusMessage?: string
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ statusMessage }) => {
  // New state and effect to show a message after 20 seconds
  const [showDelayedMessage, setShowDelayedMessage] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDelayedMessage(true)
    }, 20000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img className="mx-auto w-[240px]" src={kDefaultLogoPath} alt="Paxton" />
        <h2 className="mt-6 text-center text-1xl leading-9 tracking-tight text-brand-neutral-900">{statusMessage ? statusMessage : ''}</h2>
        <div className="mt-10 text-center">
          <CircularProgressContinuousSized size={24} thickness={5} />
        </div>
        {showDelayedMessage && (
          <div className="mt-4 text-center text-sm text-gray-500">
            Things are taking a little longer than expected! We are experiencing some hiccups. Please wait a few minutes and then refresh the page.
          </div>
        )}
      </div>
    </div>
  )
}

export default FullPageLoader
